export default "__VITE_ASSET__2AXnx02R__"